<template>
    <Layout>

        <div slot="titlebarSecondRow">
            <SubNavBar :struct="tabStructure"></SubNavBar>
        </div>

        <div class="company">
            <section class="fieldset">
                <LoadingLight id="logoUpload"></LoadingLight>
                <h3>{{ $t("papers.tabSociety.logo") }}</h3>
                <div class="container-logo-outer">
                    <div v-if="currentLogo" class="container-logo">
                        <img :src="currentLogo" alt="Logo">
                    </div>
                    <PictureInput v-can="'admin-logo-client'" ref="pictureInput" @change="onChange" @error="onError" name="logo" width="800"
                                  height="200" size="1" :hideChangeButton="true" :toggleAspectRatio="false"
                                  :autoToggleAspectRatio="true"></PictureInput>
                    <div v-can="'admin-logo-client'" class="change-placeholder">
                        <font-awesome-icon icon="pencil" size="2x"/>
                        <span>{{ $t("papers.tabSociety.modifyLogo") }}</span>
                    </div>
                </div>
                <p class="p-logo" v-can="'admin-logo-client'">
                  {{ $t("papers.tabSociety.logoFormat") }}
                </p>


            </section>

            <section class="fieldset">
                <h3> {{ $t("papers.tabSociety.address") }}</h3>
                <div class="row">
                    <div class="col-12">
                        <font-awesome-icon icon="home"/>
                        <strong>{{ clientInfos.society_name }}</strong><br>
                        {{ clientInfos.address1 }}<br>
                        <span v-html="clientInfos.address2 ? ( clientInfos.address2 + '<br>' ) : ''"></span>
                        {{ clientInfos.zip_code }} {{ clientInfos.city }}
                    </div>
                    <div class="col-md-6">
                        <font-awesome-icon icon="phone"/>
                        <strong>{{ $t("papers.tabSociety.tel") }}</strong> : {{ clientInfos.phone ? clientInfos.phone : 'Aucun' }}
                    </div>
                    <div class="col-md-6">
                        <font-awesome-icon icon="fax"/>
                        <strong>{{ $t("papers.tabSociety.fax") }}</strong> : {{ clientInfos.fax ? clientInfos.fax : 'Aucun' }}
                    </div>
                </div>
            </section>

            <!--<section class="fieldset">
                <h3>Paramètres</h3>
            </section>-->

            <section class="fieldset">
                <h3>{{ $t("papers.tabSociety.agencies") }}</h3>

                <table class="table" v-if="isClientInfosValid">
                    <thead>
                    <tr>
                        <th>
                            Nom
                        </th>
                        <th>
                            Univers
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>test</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>test</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>test</td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>

                <div v-else>
                    <div class="no-result">{{ $t("papers.tabSociety.noAgency") }}</div>
                </div>
            </section>
        </div>


        <div slot="toolbar">
            <Btn v-can="'admin-logo-client'" :class="'primary mobile-block pull-right'" @click.native="updatePicture()">{{ $t("global.save") }}</Btn>
        </div>

    </Layout>
</template>

<script>
    import Layout from '@l/BaseWithToolbar'

    import SubNavBar from '@c/ui/SubNavBar'
    import PictureInput from '@c/ui/PictureInput'
    import axios from 'axios';
    import Utils from '@s/utils'

    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import LoadingLight from "../../components/ui/LoadingLight";


    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {
            this.$store.commit('UI/viewTitle',window.V.$i18n.t('papers.titles.society'))
        },
        beforeUpdate: function () {
        },
        components: {
            LoadingLight,
            Layout,
            SubNavBar,
            PictureInput
        },
        computed: {
            ...mapGetters({
                logo: 'Papers/logo',
                clientInfos: 'Papers/clientInfos',
                errors: 'Papers/errors'
            }),
            tabStructure() {
              return [
                {name: window.V.$i18n.t("papers.tabsBar.society") , path: 'papersIndex', permission: 'admin-company-client', active: true},
                {name: window.V.$i18n.t("papers.tabsBar.interlocutors") , path: 'interlocutors', permission: 'admin-contacts-client'},
                {name: window.V.$i18n.t("papers.tabsBar.bills") , path: 'bills', permission: 'admin-bills-client'},
                {name: window.V.$i18n.t("papers.tabsBar.administrativeAsk"), path: 'drc', permission: 'admin-bills-client'}
              ];
            },
            isClientInfosValid() {
                return this.clientInfos && this.clientInfos.agencies && this.clientInfos.agencies.length > 0;
            },
            currentLogo(){
                if(this.picture != ''){
                    return this.picture
                }
                else if(this.logo != ''){
                    return this.logo
                }
                else{
                    return ''
                }
            }
        },
        created: function () {
        },
        data() {
            return {
                picture: ''
            }
        },
        destroyed: function () {
            this.setErrors({})
        },
        methods: {
            ...mapMutations({
                setViewTitle: 'UI/viewTitle',
                showLoading: 'UI/showLoading',
                showLoadingLight: 'UI/showLoadingLight',
                setErrors: 'Papers/errors',
                addSuccess: 'Messages/addSuccess',
                addError: 'Messages/addError',
                clearMessages: 'Messages/clearMessages'
            }),
            ...mapActions({
                putLogo: 'Papers/putLogo',
                getLogo: 'Papers/getLogo',
                deleteLogo: 'Papers/deleteLogo',
                getClientInfos: 'Papers/getClientInfos'
            }),
            updatePicture() {
                this.showLoadingLight({id: 'logoUpload', show: true})
                this.putLogo(this.picture)
                    .then(response => {
                        this.clearMessages()
                        this.addSuccess('Vos données ont bien été enregistrées')
                        this.getLogo();
                        this.$refs.pictureInput.removeImage()
                        this.showLoadingLight({id: 'logoUpload', show: false})
                    })
                    .catch(error => {
                        //context.commit('errors',error.response.data);
                        this.addError(error.response.data.message)
                        this.showLoadingLight({id: 'logoUpload', show: false})
                    });
            },
            onChange() {
                const image = this.$refs.pictureInput.image;
                if (image) {
                    this.picture = image
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            onError(err, vm, info) {
                //console.warn(err);
                this.addError(err.message)
            },
            removeLogo() {
                this.deleteLogo();
            }
        },
        mounted: function () {
            const getlogo = this.getLogo();
            //const getClientInfos = this.getClientInfos();

            Promise.all([getlogo]).then(() => {
                this.showLoading(false);

            });
        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
  .company {
      img {
          max-width: 100%;
          height: auto;
      }
      .p-logo {
          margin-top: 15px;
          text-align: center;
          font-size: 14px;
      }
      .container-logo {
          text-align: center;
          margin-bottom: 15px;
      }
      .link-remove {
          margin-top: 5px;
          font-size: 12px;
          color: $error;
      }
      .link-remove:hover {
          text-decoration: underline;
          cursor: pointer;
      }
      .no-result {
          text-align: center;
          font-size: 16px;
          margin: 15px 0;
      }
      .no-logo {
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          font-size: 16px;
      }
      .container-logo-outer{
          position: relative;
          width: auto;
          height: 20vh;
          margin: auto;

          .container-logo{
              pointer-events: none;
              height: 100%;

              img{
                  height: 100%;
              }
          }
          .picture-input{
              position: absolute;
              top: 0;
              opacity: 0;
              z-index: 1;
              width: 100%;
              height: 100%;
          }
          .change-placeholder{
              opacity: 0;
              position: absolute;
              top: 0;
              width: 100%;
              height: 100%;
              transition-property: opacity;
              background-color: rgba($sfr-color,0.6);
              color: $main-white;
              display: flex;
              flex-direction: column;
              padding: 20px 0;

              &>*{
                  display: block;
                  flex: 1 0 auto;
                  align-self: center;
                  text-align: center;
              }
              &.svg-inline--fa{

              }
          }
          &:hover{
              .change-placeholder{
                  opacity: 1;
              }
          }
      }
  }
  .sfr {
    .company {
      img {
        max-width: 100%;
        height: auto;
      }
      .p-logo {
        margin-top: 15px;
        text-align: center;
        font-size: 14px;
      }
      .container-logo {
        text-align: center;
        margin-bottom: 15px;
      }
      .link-remove {
        margin-top: 5px;
        font-size: 12px;
        color: $error;
      }
      .link-remove:hover {
        text-decoration: underline;
        cursor: pointer;
      }
      .no-result {
        text-align: center;
        font-size: 16px;
        margin: 15px 0;
      }
      .no-logo {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 16px;
      }
      .container-logo-outer{
        position: relative;
        width: auto;
        height: 20vh;
        margin: auto;

        .container-logo{
          pointer-events: none;
          height: 100%;

          img{
            height: 100%;
          }
        }
        .picture-input{
          position: absolute;
          top: 0;
          opacity: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
        }
        .change-placeholder{
          opacity: 0;
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          transition-property: opacity;
          background-color: rgba($beepiz-color,0.6);
          color: $main-white;
          display: flex;
          flex-direction: column;
          padding: 20px 0;

          &>*{
            display: block;
            flex: 1 0 auto;
            align-self: center;
            text-align: center;
          }
          &.svg-inline--fa{

          }
        }
        &:hover{
          .change-placeholder{
            opacity: 1;
          }
        }
      }
    }
  }
  .beepiz {
    .company {
      img {
        max-width: 100%;
        height: auto;
      }
      .p-logo {
        margin-top: 15px;
        text-align: center;
        font-size: 14px;
      }
      .container-logo {
        text-align: center;
        margin-bottom: 15px;
      }
      .link-remove {
        margin-top: 5px;
        font-size: 12px;
        color: $error;
      }
      .link-remove:hover {
        text-decoration: underline;
        cursor: pointer;
      }
      .no-result {
        text-align: center;
        font-size: 16px;
        margin: 15px 0;
      }
      .no-logo {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 16px;
      }
      .container-logo-outer{
        position: relative;
        width: auto;
        height: 20vh;
        margin: auto;

        .container-logo{
          pointer-events: none;
          height: 100%;

          img{
            height: 100%;
          }
        }
        .picture-input{
          position: absolute;
          top: 0;
          opacity: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
        }
        .change-placeholder{
          opacity: 0;
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          transition-property: opacity;
          background-color: rgba($beepiz-color,0.6);
          color: $main-white;
          display: flex;
          flex-direction: column;
          padding: 20px 0;

          &>*{
            display: block;
            flex: 1 0 auto;
            align-self: center;
            text-align: center;
          }
          &.svg-inline--fa{

          }
        }
        &:hover{
          .change-placeholder{
            opacity: 1;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/papers/Index.vue